import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolumeUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volume_up"}/>
}
